import { useTranslation } from "react-i18next";
import { TiTick } from "react-icons/ti";
import { MdFileDownload } from "react-icons/md";
import { useEffect, useState } from "react";

export default function PrivacyBox({
  handleVerifyread,
  handleDownloadPdf,
  read,
}) {
  const { t } = useTranslation("global");
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const verified = localStorage.getItem("verified");

    if (verified) {
      setChecked(true);
    }
  }, []);

  return (
    <div className="bg-white/60 rounded-xl shadow-warm max-w-3xl mx-auto relative">
      <div
        className={` ${
          !read ? "bg-gray-500" : "bg-navyBlue"
        } p-1 rounded-full w-fit absolute left-[50%] transition-all -translate-x-[50%] -translate-y-[50%]`}
      >
        <TiTick className="text-8xl text-white" />
      </div>

      <div className="pt-20 px-6 lg:px-20 pb-10">
        <p className="text-2xl lg:text-3xl font-semibold text-center text-navyBlue">
          {t("privacySection.title")}
        </p>

        <div className="flex items-start gap-x-2 mt-5 lg:mt-10">
          <input
            type="checkbox"
            id="verifyread"
            checked={checked}
            disabled={!read}
            onChange={() => {
              handleVerifyread();
              setChecked(!checked);
            }}
            className="h-4 w-4 rounded-full mt-1 accent-navyBlue cursor-pointer"
          />

          <p className="lg:text-lg font-medium">
            {t("privacySection.checkboxLabel")}
          </p>
        </div>

        <button
          className="text-white mt-4 shadow-warm hover:brightness-110 hover:shadow-none transition-all bg-navyBlue py-1 rounded-lg flex w-fit items-center px-6 gap-x-4 justify-between"
          onClick={handleDownloadPdf}
        >
          <span> {t("privacySection.downloadBtn")}</span>

          <MdFileDownload className="text-xl" />
        </button>

        <h3 className="mt-6">
          {t("privacySection.clickMessage")
            .split("")
            .map((l, idx) => (
              <span
                key={idx}
                className={`${idx > 4 && idx < 35 && "text-skyBlue"}`}
              >
                {l}
              </span>
            ))}
        </h3>
      </div>
    </div>
  );
}
